import _axios from '@/util/httpConfig.js'

// 获取窗口步骤RES005D60C01B8AD9B
// 获取邮寄受理RESE6308ADD56E6DA9

// 联系我们 RES6667B5CF324C0A5
// 认证简介 RESF066B8131D4CA82
export const getStep = (contentCode) => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}


export const getContentCode = (moduleCode) => {
  let data = {
    moduleCode,
    tenantCode: '96F307B9D0EDF9F',
    appCode: 'APPAFBB8CD316AFF62',
  }
  return _axios("POST", `/common-content/contentAnnounce/list`, data)
}
// 获取网上办事大厅链接RES427D66A88869383
// 获取查验 RESC807153A8EA8E5F
// 获取进度查询RESBC899070F25B330

// 便民检索 RES12A08BAF96DF6D9
export const getLinks = (moduleCode) => {
  let data = {
    appCode: 'APPAFBB8CD316AFF62',
    moduleCode: moduleCode,
    pageNo: 0,
    pageSize: 1000,
    tenantCode: '96F307B9D0EDF9F'
  }
  return _axios('post', `/common-content/contentLink/list`, data)
}
export const getTitle = () => {
  let data = {
    appCode: 'APPAFBB8CD316AFF62',
    moduleName: '',
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RESC66C3D15FE44800",
    resourceName: "",
    status: "E",
    tenantCode: '96F307B9D0EDF9F'
  }
  return _axios('post', `/common-content/contentModule/list`, data)
}
export const getConsularTitle = () => {
  let data = {
    appCode: 'APPAFBB8CD316AFF62',
    moduleName: '',
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RESD1CB07C795C4F2D",
    resourceName: "",
    status: "E",
    tenantCode: '96F307B9D0EDF9F'
  }
  return _axios('post', `/common-content/contentModule/list`, data)
}
export const getConsularDetails = (code) => {
  let data = {
    appCode: "APPAFBB8CD316AFF62",
    contentStatus: "",
    contentTitle: "",
    moduleCode: code,
    moduleNavCode: "",
    pageNo: 0,
    pageSize: 0,
    status: "",
    tenantCode: "96F307B9D0EDF9F",
    typeCode: ""
  }
  return _axios('post', `/common-content/contentAnnounce/list`, data)
}
export const getLink = (contentCode) => {
  let data = {
    appCode: 'APPAFBB8CD316AFF62',
    contentCode: contentCode,
    tenantCode: '96F307B9D0EDF9F'
  }
  return _axios('GET', `/common-content/contentLink/get?linkCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}

// 获取列表
// 认证答疑 RES415CAEC37D7A196
export const getList = (moduleCode) => {
  const data = { 
    "appCode": "APPAFBB8CD316AFF62",
   "contentStatus": "",
    "contentTitle": "",
     "moduleCode": moduleCode,
      "moduleNavCode": "",
       "pageNo": 0, 
       "pageSize": 4, 
       "status": "", 
       "tenantCode": "96F307B9D0EDF9F",
        "typeCode": "" }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 查询邮寄办理的认证材料表格
export const getMaterial = (name) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "countryName": name,
    "pageNo": 1,
    "pageSize": 10,
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/authMaterial/list', '', data)
}

// 查询邮寄办理的认证费用
export const getCost = (name) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "countryName": name,
    "pageNo": 1,
    "pageSize": 10,
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/authCost/list', '', data)
}
// 获取一站式列表
export const getOneStopShop = ({ regionCode, regionCodeFullPath, regionParentCode, pageNo = 1, pageSize = 6, officeName } = {}) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "officeName": officeName,
    "pageNo": pageNo,
    "pageSize": pageSize,
    "regionCode": regionCode,
    "regionCodeFullPath": regionCodeFullPath,
    "regionParentCode": regionParentCode,
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/notarialOffice/list', '', data)
}

// 获取中国区域
export const getArea = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "tenantCode": "96F307B9D0EDF9F",
    "fullPathCode": "350000",
    "pageSize": 999,
    "minLevel": 1,
    "maxLevel": 3
  }
  return _axios('POST', '/common-content/region/list', '', data)
}

// 邮寄认证材料
export const getMaterialList = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RES4C8C5399ACE990C&tenantCode=96F307B9D0EDF9F`)
}
// 邮寄认证费用
export const getMaterCertCost = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RES0D261CF3C2A2DE5&tenantCode=96F307B9D0EDF9F`)
}
// 邮寄办理步骤
export const mailHandlerStep = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RES005D60C01B8AD9B&tenantCode=96F307B9D0EDF9F`)
}

// 窗口认证材料
export const getWinMaterialList = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RES332DAF7A1473125&tenantCode=96F307B9D0EDF9F`)
}
//窗口认证费用
export const getWinMaterCertCost = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RESF793CC044524518&tenantCode=96F307B9D0EDF9F`)
}
// 窗口办理步骤
export const windowHandlerStep = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RESE6308ADD56E6DA9&tenantCode=96F307B9D0EDF9F`)
}


// WEBPACK FOOTER //
// ./src/api/consularCertification.js